import React from 'react';
import classnames from 'classnames';
import {Field} from 'formik';
import markFilledInput from "../../assets/markFilledInput.svg";
import TextareaAutosize from "react-textarea-autosize";
import styles from './styles.module.scss';

const FieldTextareaAutosize = ({
                                 fieldId,
                                 label = null,
                                 mandatoryMark = false,
                                 showBird = true,
                                 value,
                                 containerCustomStyles = null,
                                 customLabelStyles = null,
                                 customTextareaStyles = null,
                                 disabled = false,
                                 minRows = 1,
                                 maxRows = 30
                               }) => {

  return (
    <Field
      id={fieldId}
      name={fieldId}
    >
      {({field, meta}) => (
        <label className={classnames(styles.textareaContainer, containerCustomStyles)}>
          <div className={classnames(styles.labelContainer,
            {[styles.errorLabel]: meta.error && meta.touched},
            customLabelStyles)}
          >
            {mandatoryMark && <span className={styles.mandatoryMark}>*</span>}
            {label}
          </div>
          <div>
            <div
              className={classnames(styles.markFilledInputOff, {[styles.markFilledInputOn]: !meta.error && meta.value && showBird})}>
              <img
                src={markFilledInput}
                alt="markFilledInput"
              />
            </div>
            <TextareaAutosize
              disabled={disabled}
              className={classnames(styles.textarea,
                {[styles.errorBorder]: meta.error && meta.touched},
                customTextareaStyles)}
              minRows={minRows}
              maxRows={maxRows}
              style={{overflowY: 'auto'}}
              {...field}
              value={value ?? ''}
            />
          </div>
          <div className={classnames(styles.errorMessageOff, {[styles.errorMessageOn]: meta.error && meta.touched})}>
            <p className={styles.errorText}>{meta.error}</p>
          </div>
        </label>
      )}
    </Field>
  )
};

export default FieldTextareaAutosize;